import { render, staticRenderFns } from "./DefaultProductDetail.vue?vue&type=template&id=6d7e4704"
import script from "./DefaultProductDetail.vue?vue&type=script&lang=js"
export * from "./DefaultProductDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports